import {PlayersStatisticsTableRowSummaryRowApiModel} from "./players-statistics.table.row.summary-row.api-model";
import {PlayersStatisticsTableRowDomainModel} from "../players-statistics.table.row.domain-model";

export class PlayersStatisticsTableRowSummaryRowDomainModel extends PlayersStatisticsTableRowDomainModel {
  apiModel: PlayersStatisticsTableRowSummaryRowApiModel;

  get title(): String {
    return this.apiModel.title;
  }
}
